<template>
    <div class="lcbs-export">
        <el-link v-if="linkFlag" type="primary" size="mini" @click="mexport" :loading='loading' :underline="false">{{titleText}}</el-link>
        <el-button v-else type="primary" size="mini" @click="mexport" :loading='loading'>{{titleText}}</el-button>
    </div>
</template>
<script>
import request from '@/utils/http';
export default {
    name: 'lbcsExoprt',
    props: {
        params: Object,
        url: String,
        name: String,
        exportFlag: Number,
        listData: Array,
        titleText: String,
        type: {
            type: String,
            default: 'post'
        },
        linkFlag: Boolean
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        arrayBufferToString(buffer) {
            return String.fromCharCode.apply(null, new Uint8Array(buffer));
        },
        mexport() {
            if (this.type === 'post') {
                if (this.exportFlag && this.listData.length > 0) {
                    this.exportData();
                } else {
                    this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                }
            } else {
                this.exportData();
            }
        },
        exportData() {
            this.loading = true;
            request({
                url: this.url,
                method: this.type,
                data: {
                    ...this.params
                },
                responseType: 'arraybuffer'
            }).then(res => {
                if (res.byteLength < 200) {
                    const resObj = JSON.parse(this.arrayBufferToString(res));
                    if (resObj.code === '210203') {
                        this.$message.warning('数据导出总计不能超过[50,000]条，请重新选择条件查询!');
                        return;
                    }
                }
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, this.name);
                } else {
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = this.name;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                }
                this.$message.success(this.$translate('lang.E3202101250020', { defaultText: '导出成功' }));
            }).catch(() => {
                this.$message.warning(this.$translate('lang.E3202101250021', { defaultText: '导出失败' }));
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
<style lang="less">
.lcbs-export {
    display: inline-block;
}
</style>